import {
  __name,
  init_react_import
} from "./chunk-65BGW52G.mjs";

// lib/pseudoClass.ts
init_react_import();
var isDisabled = /* @__PURE__ */ __name(({ disabled }) => disabled ? "" : ":disabled", "isDisabled");
var isNotDisabled = /* @__PURE__ */ __name(({ disabled }) => disabled ? ":not(*)" : ":not(:disabled)", "isNotDisabled");
var isHovered = /* @__PURE__ */ __name(({ hovered }) => hovered ? "" : ":hover", "isHovered");
var isNotHovered = /* @__PURE__ */ __name(({ hovered }) => hovered ? ":not(*)" : ":not(:hover)", "isNotHovered");
var isFocused = /* @__PURE__ */ __name(({ focused }) => focused ? "" : ":focus", "isFocused");
var isNotFocused = /* @__PURE__ */ __name(({ focused }) => focused ? ":not(*)" : ":not(:focus)", "isNotFocused");
var isActive = /* @__PURE__ */ __name(({ active }) => active ? "" : ":focus-within", "isActive");
var isNotActive = /* @__PURE__ */ __name(({ active }) => active ? ":not(*)" : ":not(:focus-within)", "isNotActive");
var isChecked = /* @__PURE__ */ __name(({ checked }) => checked ? "" : ":checked", "isChecked");

export {
  isDisabled,
  isNotDisabled,
  isHovered,
  isNotHovered,
  isFocused,
  isNotFocused,
  isActive,
  isNotActive,
  isChecked
};
//# sourceMappingURL=chunk-UW6KP2VA.mjs.map